import React from 'react'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import { Link } from 'react-router-dom';
import Paper from '@mui/material/Paper';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Grid from '@mui/material/Grid';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import ListSortHandler from '../generic-functions/ListSortHandler'
import { FormattedMessage } from 'react-intl';


export default function DataTable({ data, indexOfFirstPost, indexOfLastPost, setData }) {

  // tabloda gösterilecek olan dataların uzunluğunu ayarlayan fonksiyon
  // d
  const slicer = (sliced) => {
    return sliced.slice(indexOfFirstPost, indexOfLastPost)
  }
  const Item = styled(Paper)(({ theme }) => ({
    ...theme.typography.body2,
    color: theme.palette.mode === 'dark' ? theme.palette.text.secondary : '#444',
    fontWeight: "450"
  }));

  const ItemHeading = styled(Paper)(({ theme }) => ({
    ...theme.typography.body2,
    color: theme.palette.mode === 'dark' ? theme.palette.text.secondary : '#616161',
    fontSize: "0.850rem"
  }));

  //  const [recipeBoolTable, setRecipeBoolTable] = React.useState(false);


  return (
    <div>
      {data.length === 0 ? "Gösterilecek data yok" :  // tablo uzunluğunun 0 olma koşulu
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              {/* Her bir başlık */}
              <TableRow>
                <TableCell className='table-head' align="left">
                  <Grid display="flex" alignItems="center" style={{ cursor: 'pointer' }}>
                    <ItemHeading>Name-Surname</ItemHeading>
                    {/* {recipeBoolTable ? <KeyboardArrowDownIcon style={{ color: "#663BB9" }} onClick={() => ListSortHandler("patient_name", !recipeBoolTable, setRecipeBoolTable, data, setData,false)} /> : <KeyboardArrowUpIcon style={{ color: "#663BB9" }} onClick={() => ListSortHandler("patient_name", !recipeBoolTable, setRecipeBoolTable, data, setData,false)} />} */}
                  </Grid>
                </TableCell>
                <TableCell className='table-head' align="left">
                  <Grid display="flex" alignItems="center" style={{ cursor: 'pointer' }}>
                    <ItemHeading><FormattedMessage id = "Create Date" /></ItemHeading>
                    {/* {recipeBoolTable ? <KeyboardArrowDownIcon style={{ color: "#663BB9" }} onClick={() => ListSortHandler("patient_birthday_new", !recipeBoolTable, setRecipeBoolTable, data, setData,true)} /> : <KeyboardArrowUpIcon style={{ color: "#663BB9" }} onClick={() => ListSortHandler("patient_birthday_new", !recipeBoolTable, setRecipeBoolTable, data, setData,true)} />} */}
                  </Grid>
                </TableCell>
              
                <TableCell className='table-head' align="left"><ItemHeading><FormattedMessage id = "Status"/></ItemHeading></TableCell>
                <TableCell className='table-head' align="left"><ItemHeading><FormattedMessage id = "Package"/></ItemHeading></TableCell>
                {/* <TableCell className='table-head' align="left"><ItemHeading><FormattedMessage id = "Last Action"/></ItemHeading></TableCell> */}
                <TableCell className='table-head' align="left"><ItemHeading><FormattedMessage id = "Doctor"/></ItemHeading></TableCell>
                {/* <TableCell className='table-head' align="left"><ItemHeading><FormattedMessage id = "Last Product"/></ItemHeading></TableCell> */}
                <TableCell className='table-head' align="left"><ItemHeading><FormattedMessage id = "Last Plan"/></ItemHeading></TableCell>
                {/* <TableCell className='table-head' align="left"><ItemHeading><FormattedMessage id = "Warranty Ends"/></ItemHeading></TableCell> */}
              </TableRow>
            </TableHead>
            <TableBody>
              {/* Her bir içerik */}
              {data.map((item, idx) => (
                <TableRow
                  key={idx}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <TableCell className='first-table-item'>
                    <Stack direction="row">
                      <Avatar
                        alt="Remy Sharp"
                        src={item.profil_pic}
                        sx={{ width: 56, height: 56 }}
                      />
                    </Stack>
                    {item.last_status_title === 0 || item.last_status_title == 16 ?
                      <Link to={{ pathname: `/create-patient/${item.id}` }}> <div style={{ cursor: 'pointer' }}>
                        <Item>
                          {JSON.parse(localStorage.getItem('userData')).role === 'ortheroanatecoutsource' || JSON.parse(localStorage.getItem('userData')).role === 'ortheroanateconyx' 
                            ? `${item.patient_name?.charAt(0) + '*'.repeat(item.patient_name?.length - 1)} ${item.patient_lastname?.charAt(0) + '*'.repeat(item.patient_lastname?.length - 1)}`
                            : `${item.patient_name} ${item.patient_lastname}`
                          }
                        </Item><span className='little-text'>{item.case_id}</span>
                      </div>
                      </Link>
                      :
                      <Link to={{ pathname: `/anateccasedetail/${item.id}` }}> <div style={{ cursor: 'pointer' }}>
                        <Item>
                          {JSON.parse(localStorage.getItem('userData')).role === 'ortheroanatecoutsource' || JSON.parse(localStorage.getItem('userData')).role === 'ortheroanateconyx' 
                            ? `${item.patient_name?.charAt(0) + '*'.repeat(item.patient_name?.length - 1)} ${item.patient_lastname?.charAt(0) + '*'.repeat(item.patient_lastname?.length - 1)}`
                            : `${item.patient_name} ${item.patient_lastname}`
                          }
                        </Item><span className='little-text'>{item.case_id}</span>
                      </div>
                      </Link>
                    }
                  </TableCell>
                  <TableCell className='table-cell' align="left"><Item>{item.created}</Item></TableCell>
                  {/* <TableCell className='table-cell' align="left"><Item>{item.patient_birthday}</Item></TableCell> */}
                  <TableCell className='table-cell' align="left"><Item><FormattedMessage id = {item.last_order.status}/></Item></TableCell>
                  <TableCell className='table-cell' align="left"><Item>{item.confirmation_analysis.analysis_type ? item.confirmation_analysis.analysis_type : "Empty"}</Item></TableCell>
                  {/* <TableCell className='table-cell' align="left"><Item>{"Data waiting"}</Item></TableCell> */}
                  <TableCell className='table-cell' align="left">
                    <Item>
                      {JSON.parse(localStorage.getItem('userData')).role === 'ortheroanatecoutsource' || JSON.parse(localStorage.getItem('userData')).role === 'ortheroanateconyx' 
                        ? item.doctor_name?.split(' ').map(word => word.charAt(0) + '*'.repeat(word.length - 1)).join(' ')
                        : item.doctor_name
                      }
                    </Item>
                  </TableCell>
                  {/* <TableCell className='table-cell' align="left"><Item>{item.last_order.lower_count === "" || item.last_order.upper_count === "" ? <FormattedMessage id = "-"/> : "U" + " " + item.last_order.lower_count + " " + "L" + " " + " " + item.last_order.lower_count}</Item></TableCell> */}
                  <TableCell className='table-cell' align="left"><Item>{item.last_order.case_plan_name}</Item></TableCell>
                  {/* <TableCell className='table-cell' align="left"><Item>{"Data waiting"}</Item></TableCell> */}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      }
    </div>
  )
}
